import React, { Component } from 'react'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import ImageOptions from './ImageOptions'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { KTColors } from '../Constants/KTColors'
import KTColorPicker from '../Constants/KTColorPicker'
import { Modal, Button } from 'react-bootstrap'
import PollInfo from './PollOptions'
import DatePicker from 'react-datepicker'
import AwsConfig from '../../Config/AwsConfig'
import CreateDynamicButton from './CreateDynamicButton'
import CreateMultiDynamicButtons from './CreateMultiDynamicButtons'
import CompressContentImage from '../../Services/Mutations/compressContentImage'

class PollContent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			pollTitle: '',
			pollDescription: '',
			urlType: 'Instagram',
			watchType: 'Off',
			instagramLink: '',
			youtubeLink: '',
			twitterLink: '',
			websiteLink: '',
			pollPositionFromTop: 35,

			crop: {
				unit: '%',
				width: 30,
				aspect: 9 / 16,
			},
			BGColorOptions: [
				{ item: 'black30', id: 1, value: KTColors.black30 },
				{ item: 'black40', id: 2, value: KTColors.black40 },
				{ item: 'black60', id: 3, value: KTColors.black60 },
				{ item: 'black', id: 4, value: KTColors.black },
			],
			selectedBGColor: KTColors.black40,
			textColorOptions: [
				{ item: 'white', id: 1, value: KTColors.white },
				{ item: 'black', id: 2, value: KTColors.black },
				{ item: 'grey', id: 3, value: KTColors.grey400 },
				{ item: 'orange', id: 4, value: '#e67300' },
			],
			selectedTextColor: KTColors.white,
			selectedPollColorOptions: [
				{ item: 'grey', id: 1, value: KTColors.grey400 },
				{ item: 'pink', id: 2, value: '#bf4080' },
				{ item: 'primaryColor', id: 3, value: KTColors.primaryColor },
				{ item: 'pink2', id: 4, value: '#993366' },
			],
			selectedPollColor: '#bf4080',
			src: null,
			cropImage: false,
			selectedImage: '',
			croppedImage: '',
			pollImage: [],
			imageSizeLimitModal: false,
			pollInfo: [],
			colorPicker: false,
			contentNewLinkDetails: {},
		}
	}
	handleTitle = (e) => {
		const title = e.target.value
		this.setState({ pollTitle: title })
		this.props.updateInParent(`pollTitle_${this.props.contentSelectedLangVal}`, title, 'Poll')
	}

	updatecontentNewLinkDetails = (linkInput) => {
		linkInput.map((buttonObj) => {
			if (buttonObj.category == 'socialMedia') {
				const input = {
					instagramLink: buttonObj.instagramLink,
					youtubeLink: buttonObj.youtubeLink,
					twitterLink: buttonObj.twitterLink,
					websiteLink: '',
					urlType: buttonObj.urlType?.replace('Link', ''),
					watchType: 'watchVideo',
				}
				this.props.updateInParent('contentLinkDetails', input, 'Poll')
			} else {
				this.props.updateInParent('contentLinkDetails', {}, 'Poll')
			}
		})
		this.props.updateInParent('contentNewLinkDetails', linkInput, 'Poll')
	}

	handleWatchType = (value) => {
		if (this.state.watchType != value) {
			this.setState(
				{
					watchType: value,
					urlType: 'Instagram',
					instagramLink: '',
					youtubeLink: '',
					twitterLink: '',
					websiteLink: '',
				},
				() => {
					this.updatecontentLinkDetails()
				}
			)
		}
	}
	updatecontentLinkDetails = () => {
		const linkInput = {
			watchType: this.state.watchType,
			instagramLink: this.state.instagramLink,
			youtubeLink: this.state.youtubeLink,
			twitterLink: this.state.twitterLink,
			websiteLink: this.state.websiteLink,
		}

		if (this.state.watchType == 'watchVideo') {
			linkInput.urlType = this.state.urlType
		}
		if (this.state.watchType == 'visitWebsite') {
			linkInput.urlType = 'website'
		}

		this.props.updateInParent('contentLinkDetails', linkInput, 'Poll')
	}
	renderContentLinkDetails = () => {
		const { urlType, watchType, youtubeLink, instagramLink, twitterLink, websiteLink } = this.state
		return (
			<div>
				<label>Social Media :</label>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'Off'}
						onChange={() => {
							this.handleWatchType('Off')
						}}
					></input>
					<text for={'Off'}>{'Off'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'watchVideo'}
						onChange={() => {
							this.handleWatchType('watchVideo')
						}}
					></input>
					<text for={'watchVideo'}>{'Watch Video'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'visitWebsite'}
						onChange={() => {
							this.handleWatchType('visitWebsite')
						}}
					></input>
					<text for={'visitWebsite'}>{'Visit Website'}</text>
				</div>
				{watchType == 'watchVideo' ? (
					<div>
						<text>{'Watch On : '}</text>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Instagram'}
								onChange={() => {
									this.handleUrlType('Instagram')
								}}
							></input>
							<text>{'Instagram'}</text>
						</div>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Youtube'}
								onChange={() => {
									this.handleUrlType('Youtube')
								}}
							></input>
							<text>{'Youtube'}</text>
						</div>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Twitter'}
								onChange={() => {
									this.handleUrlType('Twitter')
								}}
							></input>
							<text>{'Twitter'}</text>
						</div>
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Instagram' ? (
					<div>
						<text for='text'>Instagram Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handleinstagramLink(value)
							}}
							value={instagramLink}
							placeholder='Please Enter Instagram Link'
						></input>
						{this.handleinstagramLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Instagram Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Youtube' ? (
					<div>
						<text for='text'>Youtube Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handleyoutubeLink(value)
							}}
							value={youtubeLink}
							placeholder='Please Enter Youtube Link'
						></input>
						{this.handleyoutubeLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Youtube Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Twitter' ? (
					<div>
						<text for='text'>Twitter Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handletwitterLink(value)
							}}
							value={twitterLink}
							placeholder='Please Enter Twitter Link'
						></input>
						{this.handletwitterLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Twitter Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'visitWebsite' ? (
					<div>
						<text for='text'>Website Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handlewebsiteLink(value)
							}}
							value={websiteLink}
							placeholder='Please Enter Website Link'
						></input>
						{this.handlewebsiteLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Website Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
			</div>
		)
	}
	handleUrlType = (value) => {
		this.setState({ urlType: value, instagramLink: '', youtubeLink: '', twitterLink: '' }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleinstagramLink = (e) => {
		const link = e.target.value
		this.setState({ instagramLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleinstagramLinkError = () => {
		return !this.state.instagramLink != ''
	}
	handleyoutubeLink = (e) => {
		const link = e.target.value

		this.setState({ youtubeLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleyoutubeLinkError = () => {
		return !this.state.youtubeLink != ''
	}
	handletwitterLink = (e) => {
		const link = e.target.value

		this.setState({ twitterLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handletwitterLinkError = () => {
		return !this.state.twitterLink != ''
	}
	handlewebsiteLink = (e) => {
		const link = e.target.value
		this.setState({ websiteLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handlewebsiteLinkError = () => {
		return !this.state.websiteLink != ''
	}
	handleDescription = (e) => {
		this.setState({ pollDescription: e.target.value })
		this.props.updateInParent(
			`pollDescription_${this.props.contentSelectedLangVal}`,
			e.target.value,
			'Poll'
		)
	}
	renderPollStyles = () => {
		const {
			pollPositionFromTop,
			BGColorOptions,
			textColorOptions,
			selectedPollColorOptions,
			selectedBGColor,
			selectedTextColor,
			selectedPollColor,
		} = this.state
		return (
			<details>
				<summary>Poll Styles</summary>
				<div class='pollStyleRow' style={{ marginBottom: 5 }}>
					<text for='text'>Poll Position from Top </text>
					<input
						type='text'
						onChange={(e) => {
							this.handlePositionFromTop(e.target.value)
						}}
						value={pollPositionFromTop}
						placeholder='0'
					></input>
				</div>

				<div class='pollStyleRow1' style={{ marginBottom: 5 }}>
					<text for='text' style={{ fontWeight: 'bold' }}>
						Poll Bg Color :
					</text>
					<input
						type='text'
						value={selectedBGColor}
						onChange={(e) => {
							this.handleSelectedBGColor(e.target.value)
						}}
					></input>
					<div class='PollStyles' style={{ display: 'flex' }}>
						{BGColorOptions.map((item, index) => (
							<div key={index}>
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
										borderColor: selectedBGColor == item.value ? 'red' : 'transparent',
										borderStyle: 'solid',
									}}
									onClick={() => this.handleSelectedBGColor(item.value)}
								></div>
							</div>
						))}
					</div>
				</div>
				<div class='pollStyleRow2' style={{ marginBottom: 5 }}>
					<text for='text' style={{ fontWeight: 'bold' }}>
						Text Color :
					</text>
					<input
						type='text'
						value={selectedTextColor}
						onChange={(e) => {
							this.handleSelectedTextColor(e.target.value)
						}}
					></input>
					<div class='PollStyles' style={{ display: 'flex' }}>
						{textColorOptions.map((item, index) => (
							<div key={index}>
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
										borderColor: selectedTextColor == item.value ? 'red' : 'transparent',
										borderStyle: 'solid',
									}}
									onClick={() => this.handleSelectedTextColor(item.value)}
								></div>
							</div>
						))}
					</div>
				</div>
				<div class='pollStyleRow3' style={{ marginBottom: 5 }}>
					<text for='text' style={{ fontWeight: 'bold' }}>
						Selected Poll Color :
					</text>
					<input
						type='text'
						value={selectedPollColor}
						onChange={(e) => {
							this.handleSelectedPollColor(e.target.value)
						}}
					></input>
					<div class='PollStyles' style={{ display: 'flex' }}>
						{selectedPollColorOptions.map((item, index) => (
							<div key={index}>
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
										borderColor: selectedPollColor == item.value ? 'red' : 'transparent',
										borderStyle: 'solid',
									}}
									onClick={() => this.handleSelectedPollColor(item.value)}
								></div>
							</div>
						))}
					</div>
					<div style={{ marginTop: 5 }}>
						<input
							type='checkbox'
							onChange={() => this.setState({ colorPicker: !this.state.colorPicker })}
							checked={this.state.colorPicker}
							placeholder='Color picker'
						></input>
						<text>{'Color picker'}</text>
					</div>
					{this.state.colorPicker && (
						<div style={{ marginTop: 10, marginBottom: 10 }}>
							<KTColorPicker />
						</div>
					)}
				</div>
			</details>
		)
	}
	handleSelectedBGColor = (value) => {
		this.setState({ selectedBGColor: value })
		this.props.updateInParent('pollBgColor', value, 'Poll')
	}
	handleSelectedTextColor = (value) => {
		this.setState({ selectedTextColor: value })
		this.props.updateInParent('textColor', value, 'Poll')
	}
	handleSelectedPollColor = (value) => {
		this.setState({ selectedPollColor: value })
		this.props.updateInParent('selectedPollColor', value, 'Poll')
	}
	handlePositionFromTop = (value) => {
		const position = value
		this.setState({ pollPositionFromTop: position })
		this.props.updateInParent('pollPositionFromTop', position, 'Poll')
	}
	// hideImageSizeLimitModal = () => {
	// 	this.setState({
	// 		imageSizeLimitModal: false,
	// 	})
	// }
	onSelectFile = (e) => {
		let pngImageExists = false
		pngImageExists = e?.target?.files[0]?.type?.includes('png')
		if (!pngImageExists) {
			if (e.target.files && e.target.files.length > 0) {
				const reader = new FileReader()
				reader.addEventListener('load', () => this.setState({ src: reader.result }))
				reader.readAsDataURL(e.target.files[0])
				this.setState({
					cropImage: false,
					pollImage: [],
					selectedImage: e.target.files[0],
					// crop: false,
					croppedImageUrl: '',
					croppedImage: '',
				})
			}
		} else {
			this.setState({ imageSizeLimitModal: true })
		}
	}
	uploadSelectedImage = async (crop) => {
		const randomId = await uuidv4()
		const key = 'public/' + this.GetDate() + '/contents/' + randomId
		const params = {
			key: key,
			mimeType: this.state.selectedImage.type,
		}
		const preSignedURLObject = await getPreSignedURLForImageService(params)
		const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
		const signedURL = signedURLObject.data['url']
		try {
			const formData = new FormData()
			Object.keys(signedURLObject.data.fields).forEach((key) => {
				formData.append(key, signedURLObject.data.fields[key])
			})
			if (crop) {
				formData.append('file', this.state.croppedImage)
			} else {
				formData.append('file', this.state.selectedImage)
			}
			const response = await axios({
				method: 'post',
				url: signedURL,
				data: formData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			if (response.status) {
				const imageObj = {
					imageValue: this.state.croppedImageUrl ? this.state.croppedImageUrl : this.state.src,
					key: key,
					copyRightSwitch: false,
					copyRightText: '',
					shareImage: false,
				}
				const { pollImage } = this.state
				pollImage.push(imageObj)
				const input = {
					imagePath: imageObj.key
				}
				console.log(input, "===========compressImageinput")

				if (input != undefined && input != null && input.imagePath != null && input.imagePath != undefined && input.imagePath != "") {
					const response = await CompressContentImage(input)
					console.log(response, "response compress image ==========")
				}
				this.handlepollImage(pollImage)
			}
		} catch (err) {
			console.warn(err, 'err')
		}
	}
	removeSelectedImage = () => {
		this.setState({
			cropImage: false,
			pollImage: [],
			src: null,
			crop: {
				unit: '%',
				width: 30,
				aspect: 9 / 16,
			},
			croppedImageUrl: '',
			croppedImage: '',
		})
		this.props.updateInParent('pollImage', [], 'Poll')
		this.props.updateInParent('pollOriginalImages', [], 'Poll')
	}
	GetDate = () => {
		return (
			new Date().getFullYear() +
			'' +
			('0' + (new Date().getMonth() + 1)).slice(-2) +
			('0' + new Date().getDate()).slice(-2)
		)
	}
	handlepollImage = (images) => {
		const imagesArr = []
		images.filter((item) => {
			const obj = {
				image: item.image ? item.image : item.key,
				copyRight: item.copyRightSwitch,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		this.setState({ pollImage: images })
		this.props.updateInParent('pollImage', imagesArr, 'Poll')
		this.props.updateInParent('pollOriginalImages', images, 'Poll')
	}

	onImageLoaded = (image) => {
		this.imageRef = image
	}

	onCropComplete = (crop) => {
		this.makeClientCrop(crop)
	}

	onCropChange = (crop, percentCrop) => {
		this.setState({ crop })
	}

	async makeClientCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
			this.setState({ croppedImageUrl })
		}
	}
	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement('canvas')
		const pixelRatio = window.devicePixelRatio
		const scaleX = image.naturalWidth / image.width
		const scaleY = image.naturalHeight / image.height
		const ctx = canvas.getContext('2d')

		canvas.width = crop.width * pixelRatio * scaleX
		canvas.height = crop.height * pixelRatio * scaleY

		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
		ctx.imageSmoothingQuality = 'high'

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY
		)

		return new Promise((resolve, reject) => {
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						//reject(new Error('Canvas is empty'));
						console.error('Canvas is empty')
						return
					}
					blob.name = fileName
					window.URL.revokeObjectURL(this.fileUrl)
					this.fileUrl = window.URL.createObjectURL(blob)
					this.setState({ croppedImage: blob })
					resolve(this.fileUrl)
				},
				'image/jpeg',
				1
			)
		})
	}
	toggleCopyRightSwitch = (key) => {
		const { pollImage } = this.state
		pollImage.filter((item) => {
			if (item.key == key) {
				item.copyRightSwitch = !item.copyRightSwitch
			}
		})
		this.handlepollImage(pollImage)
	}

	handleCopyrightText = (key, text) => {
		const { pollImage } = this.state
		pollImage.filter((item) => {
			if (item.key == key) {
				item.copyRightText = text.target.value
			}
		})
		this.handlepollImage(pollImage)
	}
	toggleShareImageSwitch = (key, fullImage) => {
		const { pollImage } = this.state
		pollImage.filter((item) => {
			if (item.path == key || item.image == key) {
				item.shareImage = !item.shareImage
			}
		})

		this.handlepollImage(pollImage)
	}
	updatepollInfo = (pollInfo) => {
		this.setState({ pollInfo: pollInfo })
		this.props.updateInParent('pollInfo', pollInfo, 'Poll')
	}
	componentDidMount() {
		const { contentSelectedLangVal, pollDetails } = this.props
		if (!this.props.editContent) {
			this.handleSelectedBGColor(KTColors.black40)
			this.handleSelectedTextColor(KTColors.white)
			this.handleSelectedPollColor('#bf4080')
			this.handlePositionFromTop('35')
		} else if (this.props.editContent) {
			const pollImg = pollDetails.pollImage ? pollDetails.pollImage[0].image : ''
			this.setState({
				pollTitle: pollDetails[`pollTitle_${contentSelectedLangVal}`],
				pollDescription: pollDetails[`pollDescription_${contentSelectedLangVal}`],
				watchType: pollDetails.contentLinkDetails
					? pollDetails.contentLinkDetails.watchType
					: 'Off',
				urlType: pollDetails.contentLinkDetails
					? pollDetails.contentLinkDetails.urlType
					: 'Instagram',
				instagramLink: pollDetails.contentLinkDetails
					? pollDetails.contentLinkDetails.instagramLink
					: '',
				youtubeLink: pollDetails.contentLinkDetails
					? pollDetails.contentLinkDetails.youtubeLink
					: '',
				twitterLink: pollDetails.contentLinkDetails
					? pollDetails.contentLinkDetails.twitterLink
					: '',
				websiteLink: pollDetails.contentLinkDetails
					? pollDetails.contentLinkDetails.websiteLink
					: '',

				pollPositionFromTop: pollDetails.pollPositionFromTop,
				selectedBGColor: pollDetails.pollBgColor,
				selectedTextColor: pollDetails.textColor,
				selectedPollColor: pollDetails.selectedPollColor,
				pollInfo: pollDetails.pollInfo ? pollDetails.pollInfo : [],
				src: pollImg,
				pollImage: pollDetails.pollImage ? pollDetails.pollImage : [],
				contentNewLinkDetails: pollDetails.contentNewLinkDetails
					? pollDetails.contentNewLinkDetails
					: {},
			})
		}
	}

	render() {
		const {
			pollTitle,
			pollDescription,
			src,
			cropImage,
			crop,
			croppedImageUrl,
			selectedImage,
			croppedImage,
			pollImage,
			// imageSizeLimitModal,
		} = this.state
		const { data } = this.props
		return (
			<div>
				<details>
					<summary>Poll Details</summary>
					<div class='row'>
						<text for='text'>Title : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleTitle(value)
							}}
							value={pollTitle}
							placeholder='Please Enter  Title'
						></textarea>
						{!pollTitle ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Title Cannot Be Empty
							</text>
						) : null}
					</div>
					{/* {this.renderContentLinkDetails()} */}
					<CreateMultiDynamicButtons
						editContent={this.props.editContent}
						contentNewLinkDetails={this.state.contentNewLinkDetails}
						updatecontentNewLinkDetails={this.updatecontentNewLinkDetails}
					/>
					{this.renderPollStyles()}
					<div class='row'>
						<text for='text'>Poll Description : </text>
						<textarea
							type='text'
							onChange={(value) => {
								this.handleDescription(value)
							}}
							value={pollDescription}
							placeholder='Please Enter Description'
						></textarea>
					</div>
					<PollInfo
						pollDetails={this.props.pollDetails}
						updatepollInfo={this.updatepollInfo}
						contentSelectedLangVal={this.props.contentSelectedLangVal}
					/>
					<div>
						<div class='row'>
							<text for='text'>Upload Poll Image :</text>
							<p for='text' style={{ color: 'red', fontSize: 10 }}>
								(Only JPG and JPEG images are allowed)
							</p>
							<div className='App'>
								<div>
									<input type='file'
										accept=".jpg,.jpeg"
										onChange={this.onSelectFile} />
								</div>

								{!cropImage ? <img style={{ maxWidth: '100%' }} src={src} /> : null}
								{!pollImage.length && !cropImage && src && (
									<button onClick={() => this.uploadSelectedImage(false)}>Upload Image</button>
								)}
								{!pollImage.length && !cropImage && src && (
									<button onClick={() => this.setState({ cropImage: true })}>Crop Image</button>
								)}
								{cropImage && src && !pollImage.length && (
									<ReactCrop
										src={src}
										crop={crop}
										ruleOfThirds
										onImageLoaded={this.onImageLoaded}
										onComplete={this.onCropComplete}
										onChange={this.onCropChange}
									/>
								)}
								{cropImage && croppedImageUrl && (
									<img style={{ maxWidth: '100%' }} src={croppedImageUrl} />
								)}
								{src ? (
									<button onClick={() => this.removeSelectedImage()}>Remove Image</button>
								) : null}

								{!pollImage.length && croppedImageUrl ? (
									<button onClick={() => this.uploadSelectedImage(true)}>
										Upload Cropped Image
									</button>
								) : null}
								{!pollImage.length ? (
									<text for='text' style={{ color: 'red', fontSize: 10 }}>
										Please Upload Image
									</text>
								) : null}
								<div className='imagesContainer'>
									{pollImage.map((item, index) => {
										const { copyRightText, copyRightSwitch, shareImage, key } = item
										return (
											<div className='imgPreview'>
												<ImageOptions
													item={item}
													copyRightSwitch={copyRightSwitch}
													copyRightText={copyRightText}
													toggleCopyRightSwitch={(key) => this.toggleCopyRightSwitch(key)}
													handleCopyrightText={(key, text) => this.handleCopyrightText(key, text)}
													shareImage={shareImage}
													toggleShareImageSwitch={(key) => this.toggleShareImageSwitch(key)}
												/>
											</div>
										)
									})}
								</div>
							</div>
						</div>
					</div>
				</details>
				<label for='text' style={{ color: 'red', fontSize: 10 }}>
					{this.state.imageSizeLimitModal ? "Only JPG,JPEG Images are allowed" : ""}
				</label>
				{/* <Modal show={this.state.imageSizeLimitModal} onHide={() => this.hideImageSizeLimitModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Maximum allowed Image size is 900 Kb</text>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.hideImageSizeLimitModal()}>Ok</Button>
					</Modal.Footer>
				</Modal> */}
			</div>
		)
	}
}

export default PollContent
